/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Invoice confirmation phone field for cash/card payment steps in PaymentModal.
 * @module modals/PaymentModal/PaymentConfirmPhoneField
 */

import CountryCodeSelector from "../../components/CountryCodeSelector/index.jsx";
import { getSelectedCountryCodeOption } from "../../utils/common.js";
import styles from "./index.module.css";

/**
 * @param {Object} props
 * @param {string} props.labelClassName
 * @param {"cash"|"card"} props.method
 * @param {Function} props.t i18n translate function
 * @param {Array} props.countryCodeOptions
 * @param {string} props.phoneCountryCode
 * @param {string} props.confirmPhone
 * @param {Function} props.onCountryCodeChange
 * @param {Function} props.onConfirmPhoneChange
 * @param {Function} props.getFieldValidationState
 * @param {Function} props.getErrorMessage
 * @param {string} props.validationField
 */
const PaymentConfirmPhoneField = ({
  labelClassName,
  method,
  t,
  countryCodeOptions,
  phoneCountryCode,
  confirmPhone,
  onCountryCodeChange,
  onConfirmPhoneChange,
  getFieldValidationState,
  getErrorMessage,
  validationField,
}) => (
  <>
    <label className={labelClassName}>
      {t("components.paymentModal.cashSection1ConfirmPhone")}
    </label>
    <div className={styles.phoneInputContainer}>
      <CountryCodeSelector
        value={getSelectedCountryCodeOption(countryCodeOptions, phoneCountryCode)}
        onChange={(value) => onCountryCodeChange(value.value)}
      />
      <input
        type="text"
        className={`${styles.phoneInput} ${
          getFieldValidationState(validationField, confirmPhone || "") ===
          "error"
            ? styles.inputError
            : ""
        }`}
        placeholder={t("components.contactInformation.officePhonePlaceholder")}
        value={confirmPhone || ""}
        onChange={(event) => onConfirmPhoneChange(method, event.target.value)}
        style={{
          borderColor:
            getFieldValidationState(validationField, confirmPhone || "") ===
            "error"
              ? "#FF0000"
              : "#909092",
        }}
      />
    </div>
    {getErrorMessage(validationField) && (
      <p className={styles.errorMessage}>{getErrorMessage(validationField)}</p>
    )}
  </>
);

export default PaymentConfirmPhoneField;
